export default function createPubSub() {
    var subscribers = Object.create(null);
    var nextId = 0;
    function subscribe(subscriber) {
        var id = nextId++;
        subscribers[id] = subscriber;
        return function unsubscribe() {
            delete subscribers[id];
        };
    }
    function publish(event) {
        for (var id in subscribers) {
            subscribers[id](event);
        }
    }
    return {
        publish: publish,
        subscribe: subscribe,
    };
}
